import { render } from "./Tem019.vue?vue&type=template&id=4e6a9c14&scoped=true"
import script from "./Tem019.vue?vue&type=script&lang=js"
export * from "./Tem019.vue?vue&type=script&lang=js"

import "./Tem019.vue?vue&type=style&index=0&id=4e6a9c14&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e6a9c14"]])

export default __exports__